import { render, staticRenderFns } from "./EcommerceTypeDocuments.vue?vue&type=template&id=4d284aae&scoped=true&"
import script from "./EcommerceTypeDocuments.vue?vue&type=script&lang=js&"
export * from "./EcommerceTypeDocuments.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceTypeDocuments.vue?vue&type=style&index=0&id=4d284aae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d284aae",
  null
  
)

export default component.exports